import { render } from "./upload-form.vue?vue&type=template&id=dbbf7b56"
import script from "./upload-form.vue?vue&type=script&lang=js"
export * from "./upload-form.vue?vue&type=script&lang=js"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__